"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f107 = void 0;
exports.f107 = {
    "ka": [
        "Geor",
        "Brai",
        "Geok"
    ],
    "kaa": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "kab": [
        "Latn",
        "Arab",
        "Tfng"
    ],
    "kac": [
        "Latn"
    ],
    "kad": [
        "Latn"
    ],
    "kae": [
        "Zyyy"
    ],
    "kaf": [
        "Zyyy"
    ],
    "kag": [
        "Latn"
    ],
    "kah": [
        "Latn"
    ],
    "kai": [
        "Latn"
    ],
    "kaj": [
        "Latn"
    ],
    "kak": [
        "Latn"
    ],
    "kam": [
        "Latn"
    ],
    "kao": [
        "Latn"
    ],
    "kap": [
        "Cyrl"
    ],
    "kaq": [
        "Latn"
    ],
    "kav": [
        "Latn"
    ],
    "kaw": [
        "Bali"
    ],
    "kax": [
        "Latn"
    ],
    "kay": [
        "Latn"
    ],
    "kba": [
        "Latn"
    ],
    "kbb": [
        "Latn"
    ],
    "kbc": [
        "Latn"
    ],
    "kbd": [
        "Cyrl"
    ],
    "kbe": [
        "Latn"
    ],
    "kbg": [
        "Tibt"
    ],
    "kbh": [
        "Latn"
    ],
    "kbi": [
        "Latn"
    ],
    "kbj": [
        "Latn"
    ],
    "kbk": [
        "Latn"
    ],
    "kbl": [
        "Latn"
    ],
    "kbm": [
        "Latn"
    ],
    "kbn": [
        "Latn"
    ],
    "kbo": [
        "Latn"
    ],
    "kbp": [
        "Latn",
        "Brai"
    ],
    "kbq": [
        "Latn"
    ],
    "kbr": [
        "Latn",
        "Ethi"
    ],
    "kbs": [
        "Latn"
    ],
    "kbt": [
        "Latn"
    ],
    "kbu": [
        "Arab"
    ],
    "kbv": [
        "Latn"
    ],
    "kbw": [
        "Latn"
    ],
    "kbx": [
        "Latn"
    ],
    "kby": [
        "Arab",
        "Latn"
    ],
    "kbz": [
        "Latn"
    ],
    "kca": [
        "Cyrl"
    ],
    "kcb": [
        "Latn"
    ],
    "kcc": [
        "Latn"
    ],
    "kcd": [
        "Latn"
    ],
    "kce": [
        "Latn"
    ],
    "kcf": [
        "Latn"
    ],
    "kcg": [
        "Latn"
    ],
    "kch": [
        "Latn"
    ],
    "kci": [
        "Latn"
    ],
    "kcj": [
        "Latn"
    ],
    "kck": [
        "Latn"
    ],
    "kcl": [
        "Latn"
    ],
    "kcm": [
        "Latn"
    ],
    "kcn": [
        "Latn"
    ],
    "kco": [
        "Latn"
    ],
    "kcp": [
        "Latn"
    ],
    "kcq": [
        "Latn"
    ],
    "kcr": [
        "Zyyy"
    ],
    "kcs": [
        "Latn"
    ],
    "kct": [
        "Latn"
    ],
    "kcu": [
        "Latn"
    ],
    "kcv": [
        "Latn"
    ],
    "kcw": [
        "Latn"
    ],
    "kcx": [
        "Zyyy"
    ],
    "kcy": [
        "Zyyy"
    ],
    "kcz": [
        "Latn"
    ],
    "kda": [
        "Latn"
    ],
    "kdc": [
        "Latn"
    ],
    "kdd": [
        "Latn"
    ],
    "kde": [
        "Latn"
    ],
    "kdf": [
        "Latn"
    ],
    "kdg": [
        "Latn"
    ],
    "kdh": [
        "Arab",
        "Latn"
    ],
    "kdi": [
        "Latn"
    ],
    "kdj": [
        "Latn"
    ],
    "kdk": [
        "Latn"
    ],
    "kdl": [
        "Latn"
    ],
    "kdm": [
        "Latn"
    ],
    "kdn": [
        "Latn"
    ],
    "kdp": [
        "Latn"
    ],
    "kdq": [
        "Beng"
    ],
    "kdr": [
        "Latn",
        "Cyrl"
    ],
    "kdt": [
        "Thai",
        "Khmr",
        "Laoo"
    ],
    "kdu": [
        "Zyyy"
    ],
    "kdw": [
        "Latn"
    ],
    "kdx": [
        "Latn"
    ],
    "kdy": [
        "Latn"
    ],
    "kdz": [
        "Latn"
    ],
    "kea": [
        "Latn"
    ],
    "keb": [
        "Latn"
    ],
    "kec": [
        "Latn"
    ],
    "ked": [
        "Latn"
    ],
    "kee": [
        "Latn"
    ],
    "kef": [
        "Latn"
    ],
    "keg": [
        "Latn"
    ],
    "keh": [
        "Latn"
    ],
    "kei": [
        "Latn"
    ],
    "kej": [
        "Zyyy"
    ],
    "kek": [
        "Latn"
    ],
    "kel": [
        "Latn"
    ],
    "kem": [
        "Latn"
    ],
    "ken": [
        "Latn"
    ],
    "keo": [
        "Latn"
    ],
    "kep": [
        "Zyyy"
    ],
    "keq": [
        "Zyyy"
    ],
    "ker": [
        "Latn"
    ],
    "kes": [
        "Latn"
    ],
    "ket": [
        "Cyrl"
    ],
    "keu": [
        "Latn"
    ],
    "kev": [
        "Mlym",
        "Taml"
    ],
    "kew": [
        "Latn"
    ],
    "kex": [
        "Deva",
        "Gujr"
    ],
    "key": [
        "Telu"
    ],
    "kez": [
        "Latn"
    ],
    "kfa": [
        "Knda"
    ],
    "kfb": [
        "Deva"
    ],
    "kfc": [
        "Telu"
    ],
    "kfd": [
        "Knda"
    ],
    "kfe": [
        "Taml"
    ],
    "kff": [
        "Deva",
        "Latn",
        "Orya",
        "Telu"
    ],
    "kfg": [
        "Knda",
        "Mlym"
    ],
    "kfh": [
        "Mlym"
    ],
    "kfi": [
        "Taml",
        "Knda"
    ],
    "kfj": [
        "Zyyy"
    ],
    "kfk": [
        "Deva",
        "Takr"
    ],
    "kfl": [
        "Latn"
    ],
    "kfm": [
        "Arab"
    ],
    "kfn": [
        "Latn"
    ],
    "kfo": [
        "Latn"
    ],
    "kfp": [
        "Deva"
    ],
    "kfq": [
        "Deva"
    ],
    "kfr": [
        "Deva",
        "Gujr"
    ],
    "kfs": [
        "Deva"
    ],
    "kft": [
        "Zyyy"
    ],
    "kfu": [
        "Zyyy"
    ],
    "kfv": [
        "Latn"
    ],
    "kfw": [
        "Latn"
    ],
    "kfx": [
        "Deva",
        "Takr"
    ],
    "kfy": [
        "Deva"
    ],
    "kfz": [
        "Latn"
    ],
    "kg": [
        "Latn"
    ],
    "kga": [
        "Latn"
    ],
    "kgb": [
        "Latn"
    ],
    "kge": [
        "Latn"
    ],
    "kgf": [
        "Latn"
    ],
    "kgg": [
        "Zyyy"
    ],
    "kgi": [
        "Zxxx"
    ],
    "kgj": [
        "Deva"
    ],
    "kgk": [
        "Latn"
    ],
    "kgl": [
        "Latn"
    ],
    "kgm": [
        "Latn"
    ],
    "kgn": [
        "Zyyy"
    ],
    "kgo": [
        "Latn"
    ],
    "kgp": [
        "Latn"
    ],
    "kgq": [
        "Latn"
    ],
    "kgr": [
        "Latn"
    ],
    "kgs": [
        "Latn"
    ],
    "kgt": [
        "Latn"
    ],
    "kgu": [
        "Latn"
    ],
    "kgv": [
        "Latn"
    ],
    "kgw": [
        "Latn"
    ],
    "kgx": [
        "Latn"
    ],
    "kgy": [
        "Zyyy"
    ],
    "kha": [
        "Latn",
        "Beng"
    ],
    "khb": [
        "Talu",
        "Lana"
    ],
    "khc": [
        "Latn"
    ],
    "khd": [
        "Latn"
    ],
    "khe": [
        "Latn"
    ],
    "khf": [
        "Thai"
    ],
    "khg": [
        "Tibt"
    ],
    "khh": [
        "Latn"
    ],
    "khj": [
        "Latn"
    ],
    "khl": [
        "Latn"
    ],
    "khn": [
        "Deva"
    ],
    "kho": [
        "Brah",
        "Khar"
    ],
    "khp": [
        "Latn"
    ],
    "khq": [
        "Latn"
    ],
    "khr": [
        "Latn",
        "Deva"
    ],
    "khs": [
        "Latn"
    ],
    "kht": [
        "Mymr"
    ],
    "khu": [
        "Latn"
    ],
    "khv": [
        "Cyrl"
    ],
    "khw": [
        "Arab"
    ],
    "khx": [
        "Latn"
    ],
    "khy": [
        "Latn"
    ],
    "khz": [
        "Latn"
    ],
    "ki": [
        "Latn"
    ],
    "kia": [
        "Latn"
    ],
    "kib": [
        "Latn"
    ],
    "kic": [
        "Latn"
    ],
    "kid": [
        "Latn"
    ],
    "kie": [
        "Latn"
    ],
    "kif": [
        "Deva"
    ],
    "kig": [
        "Latn"
    ],
    "kih": [
        "Latn"
    ],
    "kii": [
        "Zyyy"
    ],
    "kij": [
        "Latn"
    ],
    "kil": [
        "Latn"
    ],
    "kim": [
        "Cyrl"
    ],
    "kio": [
        "Latn"
    ],
    "kip": [
        "Deva"
    ],
    "kiq": [
        "Latn"
    ],
    "kis": [
        "Latn"
    ],
    "kit": [
        "Latn"
    ],
    "kiu": [
        "Latn"
    ],
    "kiv": [
        "Latn"
    ],
    "kiw": [
        "Latn"
    ],
    "kix": [
        "Latn"
    ],
    "kiy": [
        "Latn"
    ],
    "kiz": [
        "Latn"
    ],
    "kj": [
        "Latn",
        "Brai"
    ],
    "kja": [
        "Latn"
    ],
    "kjb": [
        "Latn"
    ],
    "kjc": [
        "Latn"
    ],
    "kjd": [
        "Latn"
    ],
    "kje": [
        "Latn"
    ],
    "kjf": [
        "Zyyy"
    ],
    "kjg": [
        "Laoo",
        "Latn",
        "Thai"
    ],
    "kjh": [
        "Cyrl"
    ],
    "kji": [
        "Latn"
    ],
    "kjj": [
        "Latn"
    ],
    "kjk": [
        "Latn"
    ],
    "kjl": [
        "Deva"
    ],
    "kjm": [
        "Latn"
    ],
    "kjn": [
        "Latn"
    ],
    "kjo": [
        "Deva"
    ],
    "kjp": [
        "Mymr",
        "Leke",
        "Thai"
    ],
    "kjq": [
        "Latn"
    ],
    "kjr": [
        "Latn"
    ],
    "kjs": [
        "Latn"
    ],
    "kjt": [
        "Thai"
    ],
    "kju": [
        "Latn"
    ],
    "kjv": [
        "Latn"
    ],
    "kjx": [
        "Latn"
    ],
    "kjy": [
        "Latn"
    ],
    "kjz": [
        "Tibt"
    ],
    "kk": [
        "Cyrl",
        "Arab",
        "Brai",
        "Latn"
    ],
    "kka": [
        "Latn"
    ],
    "kkb": [
        "Latn"
    ],
    "kkc": [
        "Latn"
    ],
    "kkd": [
        "Latn"
    ],
    "kke": [
        "Latn",
        "Arab"
    ],
    "kkf": [
        "Tibt"
    ],
    "kkg": [
        "Latn"
    ],
    "kkh": [
        "Lana"
    ],
    "kki": [
        "Latn"
    ],
    "kkj": [
        "Latn"
    ],
    "kkk": [
        "Latn"
    ],
    "kkl": [
        "Latn"
    ],
    "kkm": [
        "Latn"
    ],
    "kkn": [
        "Zyyy"
    ],
    "kko": [
        "Latn"
    ],
    "kkp": [
        "Latn"
    ],
    "kkq": [
        "Latn"
    ],
    "kkr": [
        "Latn"
    ],
    "kks": [
        "Latn"
    ],
    "kkt": [
        "Deva"
    ],
    "kku": [
        "Latn"
    ],
    "kkv": [
        "Latn"
    ],
    "kkw": [
        "Latn"
    ],
    "kkx": [
        "Latn"
    ],
    "kky": [
        "Latn"
    ],
    "kkz": [
        "Latn"
    ],
    "kl": [
        "Latn"
    ],
    "kla": [
        "Latn"
    ],
    "klb": [
        "Latn"
    ],
    "klc": [
        "Latn"
    ],
    "kld": [
        "Latn"
    ],
    "kle": [
        "Deva"
    ],
    "klf": [
        "Latn"
    ],
    "klg": [
        "Latn"
    ],
    "klh": [
        "Latn"
    ],
    "kli": [
        "Latn"
    ],
    "klj": [
        "Zyyy"
    ],
    "klk": [
        "Latn"
    ],
    "kll": [
        "Latn"
    ],
    "klm": [
        "Latn"
    ],
    "kln": [
        "Latn"
    ],
    "klo": [
        "Latn"
    ],
    "klp": [
        "Latn"
    ],
    "klq": [
        "Latn"
    ],
    "klr": [
        "Deva"
    ],
    "kls": [
        "Latn",
        "Arab"
    ],
    "klt": [
        "Latn"
    ],
    "klu": [
        "Latn"
    ],
    "klv": [
        "Latn"
    ],
    "klw": [
        "Latn"
    ],
    "klx": [
        "Latn"
    ],
    "kly": [
        "Latn"
    ],
    "klz": [
        "Latn"
    ],
    "km": [
        "Khmr"
    ],
    "kma": [
        "Latn"
    ],
    "kmb": [
        "Latn"
    ],
    "kmc": [
        "Latn",
        "Hani"
    ],
    "kmd": [
        "Latn"
    ],
    "kme": [
        "Latn"
    ],
    "kmf": [
        "Latn"
    ],
    "kmg": [
        "Latn"
    ],
    "kmh": [
        "Latn"
    ],
    "kmi": [
        "Latn"
    ],
    "kmj": [
        "Deva"
    ],
    "kmk": [
        "Latn"
    ],
    "kml": [
        "Latn"
    ],
    "kmm": [
        "Latn"
    ],
    "kmn": [
        "Latn"
    ],
    "kmo": [
        "Latn"
    ],
    "kmp": [
        "Latn"
    ],
    "kmq": [
        "Latn"
    ],
    "kms": [
        "Latn"
    ],
    "kmt": [
        "Latn"
    ],
    "kmu": [
        "Latn"
    ],
    "kmv": [
        "Latn"
    ],
    "kmw": [
        "Latn"
    ],
    "kmx": [
        "Latn"
    ],
    "kmy": [
        "Latn"
    ],
    "kmz": [
        "Arab"
    ],
    "kn": [
        "Knda",
        "Brai",
        "Nand"
    ],
    "kna": [
        "Latn"
    ],
    "knb": [
        "Latn"
    ],
    "knd": [
        "Latn"
    ],
    "kne": [
        "Latn"
    ],
    "knf": [
        "Latn"
    ],
    "kni": [
        "Latn"
    ],
    "knj": [
        "Latn"
    ],
    "knk": [
        "Latn",
        "Arab"
    ],
    "knl": [
        "Latn"
    ],
    "knm": [
        "Latn"
    ],
    "knn": [
        "Knda",
        "Latn"
    ],
    "kno": [
        "Latn"
    ],
    "knp": [
        "Latn"
    ],
    "knq": [
        "Latn"
    ],
    "knr": [
        "Latn"
    ],
    "kns": [
        "Latn",
        "Thai"
    ],
    "knt": [
        "Latn"
    ],
    "knu": [
        "Latn"
    ],
    "knv": [
        "Latn"
    ],
    "knw": [
        "Latn"
    ],
    "knx": [
        "Latn"
    ],
    "kny": [
        "Latn"
    ],
    "knz": [
        "Latn"
    ],
    "ko": [
        "Kore",
        "Brai",
        "Latn"
    ],
    "koa": [
        "Latn"
    ],
    "koc": [
        "Latn"
    ],
    "kod": [
        "Latn"
    ],
    "koe": [
        "Latn"
    ],
    "kof": [
        "Latn"
    ],
    "kog": [
        "Latn"
    ],
    "koh": [
        "Latn"
    ],
    "koi": [
        "Cyrl",
        "Latn",
        "Perm"
    ],
    "kok": [
        "Deva"
    ],
    "kol": [
        "Latn"
    ],
    "koo": [
        "Latn"
    ],
    "kop": [
        "Latn"
    ],
    "koq": [
        "Latn"
    ],
    "kos": [
        "Latn"
    ],
    "kot": [
        "Latn"
    ],
    "kou": [
        "Latn"
    ],
    "kov": [
        "Latn"
    ],
    "kow": [
        "Latn"
    ],
    "koy": [
        "Latn"
    ],
    "koz": [
        "Latn"
    ],
    "kpa": [
        "Latn"
    ],
    "kpb": [
        "Zyyy"
    ],
    "kpc": [
        "Latn"
    ],
    "kpd": [
        "Latn"
    ],
    "kpe": [
        "Latn",
        "Kpel"
    ],
    "kpf": [
        "Latn"
    ],
    "kpg": [
        "Latn"
    ],
    "kph": [
        "Latn"
    ],
    "kpi": [
        "Latn"
    ],
    "kpj": [
        "Latn"
    ],
    "kpk": [
        "Latn"
    ],
    "kpl": [
        "Latn"
    ],
    "kpm": [
        "Latn"
    ],
    "kpn": [
        "Latn"
    ],
    "kpo": [
        "Latn"
    ],
    "kpq": [
        "Latn"
    ],
    "kpr": [
        "Latn"
    ],
    "kps": [
        "Latn"
    ],
    "kpt": [
        "Cyrl"
    ],
    "kpu": [
        "Latn"
    ],
    "kpw": [
        "Latn"
    ],
    "kpx": [
        "Latn"
    ],
    "kpy": [
        "Cyrl"
    ],
    "kpz": [
        "Latn"
    ],
    "kqa": [
        "Latn"
    ],
    "kqb": [
        "Latn"
    ],
    "kqc": [
        "Latn"
    ],
    "kqd": [
        "Syrc"
    ],
    "kqe": [
        "Latn"
    ],
    "kqf": [
        "Latn"
    ],
    "kqg": [
        "Latn"
    ],
    "kqh": [
        "Latn"
    ],
    "kqi": [
        "Latn"
    ],
    "kqj": [
        "Latn"
    ],
    "kqk": [
        "Latn"
    ],
    "kql": [
        "Latn"
    ],
    "kqm": [
        "Latn"
    ],
    "kqn": [
        "Latn"
    ],
    "kqo": [
        "Latn"
    ],
    "kqp": [
        "Latn"
    ],
    "kqq": [
        "Latn"
    ],
    "kqr": [
        "Latn"
    ],
    "kqs": [
        "Latn"
    ],
    "kqt": [
        "Latn"
    ],
    "kqu": [
        "Latn"
    ],
    "kqv": [
        "Latn"
    ],
    "kqw": [
        "Latn"
    ],
    "kqx": [
        "Latn"
    ],
    "kqy": [
        "Ethi",
        "Latn"
    ],
    "kqz": [
        "Latn"
    ],
    "kr": [
        "Latn",
        "Arab"
    ],
    "kra": [
        "Deva"
    ],
    "krb": [
        "Zyyy"
    ],
    "krc": [
        "Cyrl"
    ],
    "krd": [
        "Latn"
    ],
    "kre": [
        "Latn"
    ],
    "krf": [
        "Latn"
    ],
    "krh": [
        "Latn"
    ],
    "kri": [
        "Latn"
    ],
    "krj": [
        "Latn"
    ],
    "krk": [
        "Cyrl"
    ],
    "krl": [
        "Latn",
        "Cyrl"
    ],
    "krn": [
        "Latn"
    ],
    "krp": [
        "Latn"
    ],
    "krr": [
        "Khmr"
    ],
    "krs": [
        "Latn"
    ],
    "krt": [
        "Latn"
    ],
    "kru": [
        "Deva"
    ],
    "krv": [
        "Khmr"
    ],
    "krw": [
        "Latn"
    ],
    "krx": [
        "Latn"
    ],
    "kry": [
        "Latn"
    ],
    "krz": [
        "Latn"
    ],
    "ks": [
        "Arab",
        "Deva",
        "Latn",
        "Shrd"
    ],
    "ksa": [
        "Latn"
    ],
    "ksb": [
        "Latn"
    ],
    "ksc": [
        "Latn"
    ],
    "ksd": [
        "Latn"
    ],
    "kse": [
        "Latn"
    ],
    "ksf": [
        "Latn"
    ],
    "ksg": [
        "Latn"
    ],
    "ksh": [
        "Latn"
    ],
    "ksi": [
        "Latn"
    ],
    "ksj": [
        "Latn"
    ],
    "ksk": [
        "Latn"
    ],
    "ksl": [
        "Latn"
    ],
    "ksm": [
        "Latn"
    ],
    "ksn": [
        "Latn"
    ],
    "kso": [
        "Latn"
    ],
    "ksp": [
        "Latn"
    ],
    "ksq": [
        "Latn"
    ],
    "ksr": [
        "Latn"
    ],
    "kss": [
        "Latn"
    ],
    "kst": [
        "Latn"
    ],
    "ksu": [
        "Zyyy"
    ],
    "ksv": [
        "Latn"
    ],
    "ksw": [
        "Mymr",
        "Latn"
    ],
    "ksx": [
        "Latn"
    ],
    "ksy": [
        "Zyyy"
    ],
    "ksz": [
        "Deva"
    ],
    "kta": [
        "Latn"
    ],
    "ktb": [
        "Ethi",
        "Latn"
    ],
    "ktc": [
        "Latn"
    ],
    "ktd": [
        "Latn"
    ],
    "kte": [
        "Zyyy"
    ],
    "ktf": [
        "Latn"
    ],
    "ktg": [
        "Latn"
    ],
    "kth": [
        "Latn"
    ],
    "kti": [
        "Latn"
    ],
    "ktj": [
        "Latn"
    ],
    "ktk": [
        "Latn"
    ],
    "ktl": [
        "Arab"
    ],
    "ktm": [
        "Latn"
    ],
    "ktn": [
        "Latn"
    ],
    "kto": [
        "Latn"
    ],
    "ktp": [
        "Plrd"
    ],
    "ktq": [
        "Latn"
    ],
    "kts": [
        "Latn"
    ],
    "ktt": [
        "Latn"
    ],
    "ktu": [
        "Latn"
    ],
    "ktv": [
        "Latn"
    ],
    "ktw": [
        "Latn"
    ],
    "ktx": [
        "Latn"
    ],
    "kty": [
        "Latn"
    ],
    "ktz": [
        "Latn"
    ],
    "ku": [
        "Latn",
        "Arab",
        "Armn",
        "Cyrl",
        "Yezi"
    ],
    "kub": [
        "Latn"
    ],
    "kuc": [
        "Latn"
    ],
    "kud": [
        "Latn"
    ],
    "kue": [
        "Latn"
    ],
    "kuf": [
        "Laoo"
    ],
    "kug": [
        "Latn"
    ],
    "kuh": [
        "Latn"
    ],
    "kui": [
        "Latn"
    ],
    "kuj": [
        "Latn"
    ],
    "kuk": [
        "Latn"
    ],
    "kul": [
        "Latn"
    ],
    "kum": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "kun": [
        "Latn"
    ],
    "kuo": [
        "Latn"
    ],
    "kup": [
        "Latn"
    ],
    "kuq": [
        "Latn"
    ],
    "kus": [
        "Latn"
    ],
    "kut": [
        "Latn"
    ],
    "kuu": [
        "Latn"
    ],
    "kuv": [
        "Latn"
    ],
    "kuw": [
        "Latn"
    ],
    "kux": [
        "Latn"
    ],
    "kuy": [
        "Latn"
    ],
    "kuz": [
        "Latn"
    ],
    "kv": [
        "Cyrl",
        "Cyrs",
        "Latn",
        "Perm"
    ],
    "kva": [
        "Cyrl"
    ],
    "kvb": [
        "Latn"
    ],
    "kvc": [
        "Latn"
    ],
    "kvd": [
        "Latn"
    ],
    "kve": [
        "Latn"
    ],
    "kvf": [
        "Latn"
    ],
    "kvg": [
        "Latn"
    ],
    "kvh": [
        "Latn"
    ],
    "kvi": [
        "Latn"
    ],
    "kvj": [
        "Latn"
    ],
    "kvk": [
        "Zxxx"
    ],
    "kvl": [
        "Latn"
    ],
    "kvm": [
        "Latn"
    ],
    "kvn": [
        "Latn"
    ],
    "kvo": [
        "Latn"
    ],
    "kvp": [
        "Latn"
    ],
    "kvq": [
        "Latn",
        "Mymr"
    ],
    "kvr": [
        "Latn",
        "Rjng"
    ],
    "kvt": [
        "Mymr"
    ],
    "kvu": [
        "Zyyy"
    ],
    "kvv": [
        "Latn"
    ],
    "kvw": [
        "Latn"
    ],
    "kvx": [
        "Arab"
    ],
    "kvy": [
        "Zyyy"
    ],
    "kvz": [
        "Latn"
    ],
    "kw": [
        "Latn"
    ],
    "kwa": [
        "Latn"
    ],
    "kwb": [
        "Latn"
    ],
    "kwc": [
        "Latn"
    ],
    "kwd": [
        "Latn"
    ],
    "kwe": [
        "Latn"
    ],
    "kwf": [
        "Latn"
    ],
    "kwg": [
        "Latn"
    ],
    "kwh": [
        "Latn"
    ],
    "kwi": [
        "Latn"
    ],
    "kwj": [
        "Latn"
    ],
    "kwk": [
        "Latn"
    ],
    "kwl": [
        "Latn"
    ],
    "kwm": [
        "Latn"
    ],
    "kwn": [
        "Latn"
    ],
    "kwo": [
        "Latn"
    ],
    "kwp": [
        "Latn"
    ],
    "kwr": [
        "Latn"
    ],
    "kws": [
        "Latn"
    ],
    "kwt": [
        "Latn"
    ],
    "kwu": [
        "Latn"
    ],
    "kwv": [
        "Latn"
    ],
    "kww": [
        "Latn"
    ],
    "kwx": [
        "Zyyy"
    ],
    "kwy": [
        "Latn"
    ],
    "kwz": [
        "Latn"
    ],
    "kxa": [
        "Latn"
    ],
    "kxb": [
        "Latn"
    ],
    "kxc": [
        "Latn",
        "Ethi"
    ],
    "kxd": [
        "Latn",
        "Arab"
    ],
    "kxf": [
        "Mymr",
        "Latn"
    ],
    "kxh": [
        "Zyyy"
    ],
    "kxi": [
        "Latn"
    ],
    "kxj": [
        "Latn"
    ],
    "kxk": [
        "Mymr"
    ],
    "kxm": [
        "Thai",
        "Khmr"
    ],
    "kxn": [
        "Latn"
    ],
    "kxo": [
        "Latn"
    ],
    "kxp": [
        "Arab",
        "Gujr"
    ],
    "kxq": [
        "Latn"
    ],
    "kxr": [
        "Latn"
    ],
    "kxs": [
        "Zyyy"
    ],
    "kxt": [
        "Latn"
    ],
    "kxu": [
        "Orya"
    ],
    "kxv": [
        "Orya",
        "Telu"
    ],
    "kxw": [
        "Latn"
    ],
    "kxx": [
        "Latn"
    ],
    "kxy": [
        "Latn"
    ],
    "kxz": [
        "Latn"
    ],
    "ky": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "kya": [
        "Latn"
    ],
    "kyb": [
        "Latn"
    ],
    "kyc": [
        "Latn"
    ],
    "kyd": [
        "Latn"
    ],
    "kye": [
        "Latn"
    ],
    "kyf": [
        "Latn"
    ],
    "kyg": [
        "Latn"
    ],
    "kyh": [
        "Latn"
    ],
    "kyi": [
        "Latn"
    ],
    "kyj": [
        "Latn"
    ],
    "kyk": [
        "Latn"
    ],
    "kyl": [
        "Latn"
    ],
    "kym": [
        "Latn"
    ],
    "kyn": [
        "Latn"
    ],
    "kyo": [
        "Latn"
    ],
    "kyp": [
        "Zyyy"
    ],
    "kyq": [
        "Latn"
    ],
    "kyr": [
        "Latn"
    ],
    "kys": [
        "Latn"
    ],
    "kyt": [
        "Latn"
    ],
    "kyu": [
        "Kali",
        "Latn",
        "Mymr"
    ],
    "kyv": [
        "Deva"
    ],
    "kyw": [
        "Beng",
        "Deva",
        "Orya"
    ],
    "kyx": [
        "Latn"
    ],
    "kyy": [
        "Latn"
    ],
    "kyz": [
        "Latn"
    ],
    "kza": [
        "Latn"
    ],
    "kzb": [
        "Latn"
    ],
    "kzc": [
        "Latn"
    ],
    "kzd": [
        "Latn"
    ],
    "kze": [
        "Latn"
    ],
    "kzf": [
        "Latn"
    ],
    "kzg": [
        "Zyyy"
    ],
    "kzi": [
        "Latn"
    ],
    "kzk": [
        "Latn"
    ],
    "kzl": [
        "Latn"
    ],
    "kzm": [
        "Latn"
    ],
    "kzn": [
        "Latn"
    ],
    "kzo": [
        "Latn"
    ],
    "kzp": [
        "Latn"
    ],
    "kzq": [
        "Zyyy"
    ],
    "kzr": [
        "Latn"
    ],
    "kzs": [
        "Latn"
    ],
    "kzu": [
        "Latn"
    ],
    "kzv": [
        "Latn"
    ],
    "kzw": [
        "Latn"
    ],
    "kzx": [
        "Latn"
    ],
    "kzy": [
        "Latn"
    ],
    "kzz": [
        "Latn"
    ]
};
